<template>
  <div>
    <md-table v-model="positions" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Ticker">{{ item.ticker }}</md-table-cell>
        <md-table-cell md-label="Percent Change">{{ item.percent }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "ordered-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.getPositions();
  },
  data() {
    return {
      selected: [],
      positions: []
    };
  },
  methods: {
    getPositions() {
      axios.get(`/api/trading/member_position`)
      .then((res) => {
        this.positions = res.data;
      }).catch((err) => {
        this.error = true;
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Trading/CurrentPositionsDash.vue